<template>
  <div class="btn-group" name="MultiSelect">
    <div>
      <button :id="filteredValue" class="form-control btn btn-default dropdown-toggle ms-dropdown" type="button" ref="dropdownBtn" v-on:click="showDropdown = !showDropdown">
        <i class="fa fa-cog" :class="{ 'filterIsActive': !isAllSelected }"/>
      </button>
    </div>
    <div v-if="showDropdown" :style="drpMenuStyle">
      <div>
        <div v-if="hasMultipleGroups" class="-col-group-title">
          <input
            type="checkbox"
            :checked="allFieldsSelected"
            @change="selectAllFields(allFieldsSelected)">
          <label style="text-transform: none;"> Alle auswählen </label>
        </div>
        <div class="-col-group-container">
          <ListMS v-for="(fields, groupName) in colGroups"
            ref="colGroups" 
            :key="groupName"
            :group-name="(groupName === 'undefined') ? 'Alle auswählen' : groupName" 
            :elements="fields"
            :globChanges="globalChanges[groupName]"
            :categories="categories"
            :nChanges="nChanges">
          </ListMS>
        </div>
      </div>
      <div class="clearfix" style="margin: 10px 0">
        <div class="btn-group btn-group-sm pull-right">
          <button class="btn btn-default" type="button" @click="apply()">
            {{ $i18nForDatatable('Anwenden') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ListMS from './List_MultiSelect.vue'
import groupBy from 'lodash/groupBy'
import $ from 'jquery'
import Vue from 'vue'
import api from '@/api'
import helpers from '@/mixins/helper-functions.js'

export default {
  name: 'MultiSelect',
  components: { ListMS },
  props: {
    fields: { type: Array, required: true },
    baseWidth: Number,
    radioFilter: Boolean,
    nChanges: Object,
    filteredValue: String
  },
  data () {
    return {
      showDropdown: false,
      globalChanges: {},
      selectedColGroups: [true]
    }
  },
  mounted () {
    this.getSelectedColGroups()
    const $el = $(this.$el)
    $(this.$refs.dropdownBtn).on('click', this.toggle)
    $(document).on('click', e => {
      $(e.target).closest($el).length || $el.removeClass('open')
      if ($(e.target).closest($el).length === 0) {
        this.showDropdown = false
      }
    })
  },
  computed: {
    isWideDropdown () {
      return this.fields.length > 12
    },
    colGroups () {
      var that = this
      if (that.isWideDropdown) {
        return groupBy(that.fields, 'category')
      } else {
        return groupBy(that.fields, 'group')
      }
    },
    allFieldsSelected () {
      return this.fields.every(function (el) {
        return el.isChecked
      })
    },
    drpMenuStyle () {
      var mulWidth = (this.categories.length < 4) ? this.categories.length * 220 + 25 : 905
      return {
        'padding': '10px 10px 0',
        'top': '45px',
        'width': (this.hasMultipleGroups) ? `${mulWidth}px` : '250px',
        'border-width': '2px',
        'border-style': 'solid',
        'border-color': 'darkgrey',
        'z-index': 2001,
        'background-color': 'white',
        'opacity': 1,
        'position': 'absolute'
      }
    },
    isAllSelected () {
      return this.selectedColGroups.every(function (col) {
        return col
      })
    },
    currentFG () {
      if (this.radioFilter) {
        return (this.fields.filter(field => {
          return field.visible
        }))[0]
      }
    },
    categories () {
      return Object.keys(this.colGroups)
    },
    hasMultipleGroups () {
      return (this.categories.length > 1)
    }
  },
  methods: {
    getSelectedColGroups () {
      this.fields.forEach(field => {
        this.selectedColGroups.push(field.visible)
      })
    },
    selectAllFields (allFieldsSelected) {
      var that = this
      if (allFieldsSelected) {
        that.fields.forEach(el => {
          el.isChecked = false
          that.globalChanges[el.category].push({el, isChecked: false})
        })
      } else {
        that.fields.forEach(el => {
          el.isChecked = true
          that.globalChanges[el.category].push({el, isChecked: true})
        })
      }
    },
    async apply (alsoBackup) {
      this.showDropdown = false
      this.selectedColGroups = [true]
      this.toggle()
      this.$refs.colGroups.forEach(colGroup => {
        colGroup.apply()
        !this.radioFilter && this.selectedColGroups.push(colGroup.test())
      })
      alsoBackup && this.$nextTick(this.backup)

      // Set Cookie
      var headerSettings = {}
      this.fields.forEach(field => {
        headerSettings[field.field] = field.visible
      })
      var postResource = helpers.getPostResource(this.$route).replace('exudats/', '')
      await api.setConfigCookie({ postResource, headerSettings })
    },
    toggle () {
      $(this.$el).toggleClass('open')
    }
  },
  watch: {
    fields: {
      handler () {
        this.selectedColGroups = [true]
        this.getSelectedColGroups()
      }
    },
    categories (categ) {
      categ.forEach(c => {
        // this.globalChanges[c] = []
        Vue.set(this.globalChanges, c, [])
      })
    }
  }
}
</script>
<style>
.ms-dropdown {
  opacity: 1;
}
.ms-dropdown:hover {
  color: blue;
}
.-col-group-container {
  border-bottom: 1px solid #ddd;
}

.filterIsActive {
  color: #1DC7EA !important;
}

.filtered-value {
  font-size: 12px;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/Datatable/src/HeaderSettings/MultiSelect.vue